import * as L from "leaflet";
import { useTranslation } from "react-i18next";

import { usePoiCreateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { PoiForm, PoiFormData } from "src/forms/PoiForm";
import { useNavigate, useParams } from "react-router-dom";

interface Props {
  map: L.Map; // the map is great to have, but creating a Poi without visual marker is possible
  onClose: () => void;
}

export function PoiCreatePage(props: Props) {
  const { map } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const {caseId = ""} = useParams<{ caseId: string; poiId: string }>();

  // async data
  const { data: acase } = useCase(caseId);

  // mutations
  const createMutation = usePoiCreateMutation(caseId);

  /**
   * Functions
   */
  async function handleSave(values: PoiFormData) {
    const result = await createMutation.mutateAsync(values);
    navigate(`/cases/${caseId}/pois/${result.id}`);
  }

  return render();

  function render() {
    if (!map || !acase) return null;

    return (
      <>
        <PoiForm
          map={props.map}
          title={t("label.addPointOfInterest")}
          data={{
            name: "",
            point_frontendSrid: "",
          }}
          markerStatus="new"
          onClose={props.onClose}
          onSubmit={handleSave}
          isLoading={createMutation.isLoading}
          errors={createMutation.error?.response?.data}
        />
      </>
    );
  }
}
